export const DEFAULT_ZOOM = 2;
export const LIMIT = 1500;
